export const EVENT_ROUTE = '/event';

export const MARKET_INTENT_PARAM = 'intent';

export const TRADE_ROUTE = '/trade';

/**
 * `?pairs=open` on the terminal opens its pair list on arrival — where the
 * header search's crypto "See all" lands (read by the trade zone's
 * useOpenPairListFromUrl).
 */
export const TRADE_PAIR_LIST_PARAM = 'pairs';
export const TRADE_PAIR_LIST_OPEN = 'open';
export const TRADE_PAIR_LIST_HREF = `${TRADE_ROUTE}?${TRADE_PAIR_LIST_PARAM}=${TRADE_PAIR_LIST_OPEN}`;
